import type { DomainSourceGroup, DomainSourceSites, Overview } from "@crux/contracts";
import { api } from "../client.js";
import { problem } from "./errors.js";

/**
 * The Overview screen.
 */

export async function fetchOverview(
  workspaceId: string,
  reportId: string,
  query: {
    readonly from: string;
    readonly to: string;
    /** Omitted for every engine — the API has no wildcard value. */
    readonly engine?: string;
  },
): Promise<Overview> {
  const { data, response } = await api.GET(
    "/api/workspaces/{workspaceId}/reports/{reportId}/overview",
    { params: { path: { workspaceId, reportId }, query } },
  );
  if (data === undefined) {
    throw new Error(problem(response.status, "load this report"));
  }
  return data;
}

/** Every site in one part of the domain-sources ring, one page from `offset`. */
export async function fetchDomainSourceSites(
  workspaceId: string,
  reportId: string,
  query: {
    readonly from: string;
    readonly to: string;
    readonly engine?: string;
    readonly group: DomainSourceGroup;
    readonly offset: number;
  },
): Promise<DomainSourceSites> {
  const { data, response } = await api.GET(
    "/api/workspaces/{workspaceId}/reports/{reportId}/domain-sources",
    { params: { path: { workspaceId, reportId }, query } },
  );
  if (data === undefined) {
    throw new Error(problem(response.status, "load these sites"));
  }
  return data;
}
